'use client';

export * from './reward-machine-game-url.component';
